// extracted by mini-css-extract-plugin
export default {"header":"header_header__GNGjR","header__title":"header_header__title__-vV0b"};